<template>
  <div class="userBox">
    <el-popover
        :width="280"
        popper-style="box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px, rgb(14 18 22 / 20%) 0px 10px 20px -15px; padding: 20px;"
    >
      <template #reference>
        <div class="userImg certificationItem">
          <img v-if="certificationData.isAuth" src="./img/certification.png">
          <img v-else src="./img/certificationNo.png">
        </div>
      </template>
      <template #default>
        <div v-if="certificationData.isAuth">
          <div class="poUser">
            <div class="content">
              <div>
                <div class="userBox2">
                  <div class="userImg">
                    <img src="./img/certification.png">
                  </div>
                </div>
                <div class="userName">{{ $t('header.certification.authenticated') }}</div>
              </div>

            </div>
            <div class="account">
              <div>{{ $t('header.certification.companyName') }}</div>
              <div class="text">{{certificationData.company}}</div>
              <div>{{ $t('header.certification.creditCode') }}</div>
              <div class="text">{{certificationData.creditNo}}</div>
            </div>
          </div>

        </div>
        <div v-else>
          <div class="poUser">
            <div class="content">
              <div style="text-align: center">
                <div class="userBox2">
                  <div class="userImg">
                    <img src="./img/certificationNo.png">
                  </div>
                </div>
                <div class="userName" style="margin-left: 0">{{ $t('header.certification.unauthenticated') }}</div>
                <div class="dec">{{ $t('header.certification.pleaseCertify') }}</div>
              </div>

            </div>
          </div>
        </div>
      </template>
    </el-popover>
  </div>
</template>

<script lang="ts" setup>
  const certificationData = reactive({
    isAuth: false,                             // 是否已进行实名认证
    creditNo: "",               // 统一社会信用代码
    company: ""                         // 单位名称
  });
  const mchId = ref('');

  onMounted(async()=>{
   await getData()
  })
  const getData = async()=>{
    const {success} = await aServe.GETCompany({mchId: aStore.get('mchInfo').mchId});
    console.log(success);
    if (success) {
      certificationData.isAuth = success.isAuth
      certificationData.creditNo = success.creditNo
      certificationData.company = success.company
      aStore.set("videoServicePlan", success.dataPlan);
      aStore.set("userCompany", success);
    }
  }
</script>

<style lang="scss" scoped>
  .userBox{
    img{
      width: 50px;
      height: 50px;
    }
  }
  .poUser {
    width: 100%;

    .content {
      display: flex;
      justify-content: center;
      .userBox2 {
        img{
          width: 50px;
          height: 50px;
        }
      }
    }

    .userName {
      color: #000000;
      margin-bottom: 10px;
      margin-left: 5px;
    }
    .dec{
      color: var(--color-text-secondary);
    }

    .account {
      padding: 10px;
      background: #F1F2F4;
      border-radius: 10px;

      div {
        height: 25px;
        line-height: 25px;
      }

      .text {
        margin-bottom: 5px;
        color: #000;
      }
    }
  }
  .certificationItem {
    padding-top: 4px;
    img {
      width: 40px;
      height: 40px;
    }
  }
</style>
